export default "__VITE_ASSET__CIPE5CON__"